import * as React from 'react';
import {
    List, Datagrid, 
    SelectInput, TextInput, BooleanInput, 
    EmailField, TextField, BooleanField, SelectField, 
    Pagination
} from 'react-admin';
import { roleChoices } from './utils';

const userFilters = [
    <TextInput source="q" key="filter_q" label="User Name or Email" sx={{width: 300}} alwaysOn />,
    <SelectInput source="role" key="filter_role" label="Role" choices={roleChoices} alwaysOn />,
    <TextInput source="name" key="filter_name" label="Name" />,
    <BooleanInput source="isEmailVerified" key="filter_isEmailVerified" label="Verified" />,
];

const UserList = () => {
    return (
        <List
            filters={userFilters}
            sort={{ field: 'id', order: 'ASC' }}
            perPage={20}
            pagination={<Pagination rowsPerPageOptions={[10, 20, 50, 100]} />}
            mutationMode="pessimistic"
        >
            <Datagrid
                rowClick="edit"
                sx={{
                    '& .column-groups': {
                        md: { display: 'none' },
                        lg: { display: 'table-cell' },
                    },
                }}
            >
                <TextField source="name" />
                <EmailField source="email" />
                <BooleanField source="isEmailVerified" label="Verified" />
                <SelectField source="role" choices={roleChoices}/>
                <TextField source="id" label="ID" sx={{fontFamily: 'Monospace'}}/>
            </Datagrid>
        </List>
    );
};

export default UserList;
